// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".img[data-v-e68ebb54]{padding-bottom:69.2537313433%}.img[data-v-e68ebb54]:before{content:\"\";border-radius:.5rem;position:absolute;top:0;right:0;bottom:0;left:0;background:rgba(0,0,0,.4)}", ""]);
// Exports
module.exports = exports;
